// TO DO - Ticket Number: PPE-340 - Refactor this molecule into three different atoms

import React from 'react';
import PropTypes from 'prop-types';

export const OrderSummaryAccordionContents = ({
  orderPlacedDate,
  transactionId,
  address,
  city,
  postCode,
  exVat,
  vat,
  custName,
  custId,
}) => (
  <React.Fragment>
    <tr>
      <td className="cell hide-md" />
      <td className="cell font-bold text-left hide-md">Name</td>
      <td className="cell text-left hide-md">{custName}</td>
      <td className="cell font-bold text-left">Account Number</td>
      <td className="cell text-left">{custId}</td>
      <td className="cell hide-md" />
    </tr>
    <tr>
      <td className="cell hide-md" />
      <td className="cell text-left font-bold hide-md">Ref No.</td>
      <td className="cell text-left hide-md">{transactionId}</td>
      <td className="cell text-left font-bold hide-md">Address Line 1</td>
      <td className="cell text-left hide-md">{address}</td>
      <td className="cell hide-md" />
    </tr>
    <tr>
      <td className="cell text-left font-bold hide">Total Ex Vat</td>
      <td className="cell text-left hide">{exVat}</td>
    </tr>
    <tr>
      <td className="cell text-left font-bold hide">Address</td>
      <td className="cell text-left hide">{address}</td>
    </tr>
    <tr>
      <td className="cell hide-md" />
      <td className="cell text-left font-bold hide-md">Total Ex Vat</td>
      <td className="cell text-left hide-md">{exVat}</td>
      <td className="cell text-left font-bold">City</td>
      <td className="cell text-left">{city}</td>
      <td className="cell hide-md" />
    </tr>
    <tr>
      <td className="cell hide-md" />
      <td className="cell text-left font-bold hide-md">Vat</td>
      <td className="cell text-left hide-md">{vat}</td>
      <td className="cell text-left font-bold hide-md">Postcode</td>
      <td className="cell text-left hide-md">{postCode}</td>
      <td className="cell hide-md" />
    </tr>
    <tr>
      <td className="cell hide-md" />
      <td className="cell text-left font-bold hide-md">Order Placed</td>
      <td className="cell text-left hide-md">{orderPlacedDate}</td>
      <td className="cell text-left font-bold hide-md" />
      <td className="cell text-left hide-md" />
      <td className="cell hide-md" />
    </tr>
  </React.Fragment>
);

OrderSummaryAccordionContents.propTypes = {
  orderPlacedDate: PropTypes.string.isRequired,
  transactionId: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postCode: PropTypes.string.isRequired,
  exVat: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  custName: PropTypes.string.isRequired,
  custId: PropTypes.string.isRequired,
};

export const MissingItemsAccordionContents = ({
  itemName,
  itemSkuCode,
  itemQuantity,
}) => (
  <React.Fragment>
    <td className="cell">{itemName}</td>
    <td className="cell">{itemSkuCode}</td>
    <td className="cell">x {itemQuantity}</td>
  </React.Fragment>
);

MissingItemsAccordionContents.propTypes = {
  itemName: PropTypes.string.isRequired,
  itemSkuCode: PropTypes.number.isRequired,
  itemQuantity: PropTypes.number,
};

MissingItemsAccordionContents.defaultProps = {
  itemQuantity: 0,
};

export const YourItemsAccordionContents = ({
  itemName,
  itemQuantity,
  itemSkuCode,
  itemPrice,
  itemTotalPrice,
}) => (
  <React.Fragment>
    <td className="cell">{itemName}</td>
    <td className="cell">x {itemQuantity}</td>
    <td className="cell hide-md">{itemSkuCode}</td>
    <td className="cell hide-md">£{itemPrice}</td>
    <td className="cell">£{itemTotalPrice}</td>
  </React.Fragment>
);

YourItemsAccordionContents.propTypes = {
  itemName: PropTypes.string.isRequired,
  itemSkuCode: PropTypes.number.isRequired,
  itemQuantity: PropTypes.number,
  itemPrice: PropTypes.number.isRequired,
  itemTotalPrice: PropTypes.number.isRequired,
};

YourItemsAccordionContents.defaultProps = {
  itemQuantity: '',
};



// WEBPACK FOOTER //
// src/components/molecules/AccordionContents/index.jsx